export const PALETTE = {
	BLUE_PRIMARY: '#004494',
	LIGHT_BLUE: '#E3F2FD',
	RED_PRIMARY: '#F44336',
	YELLOW_PRIMARY: '#FFEB3B'
};
